export const getWidthInPercents = (width: number) => (width / 12) * 100
export const getColumnStyles = (width: number) => ({
  flexGrow: 0,
  maxWidth: `${getWidthInPercents(width)}%`,
  flexBasis: `${getWidthInPercents(width)}%`,
})

export const getColumnKey = (
  { label, sublabel }: { label?: string; sublabel?: string },
  index: number,
) => [label, sublabel, index].filter(Boolean).join('-')
